class MobileDotSlider {
  constructor(dotsEl) {
    this.dotsEl = dotsEl;
    this.galleryId = dotsEl.dataset.galleryTarget;
    this.slider = document.getElementById(this.galleryId);
    if (!this.slider) return;

    this.track = this.slider.querySelector('ul.slider');
    if (!this.track) return;

    this.allSlides = Array.from(this.track.children).filter((slide) => {
      const style = window.getComputedStyle(slide);
      return style.display !== 'none' && !slide.hasAttribute('hidden');
    });

    this.dots = Array.from(this.dotsEl.querySelectorAll('.mobile-dots__dot'));
    if (!this.allSlides.length || !this.dots.length) return;

    this.dotIndexByMediaId = new Map();
    this.dots.forEach((dot, i) => {
      this.dotIndexByMediaId.set(dot.dataset.mediaId, i);
    });

    // Track current visibility ratio of every observed slide
    this.ratios = new Map();
    this.allSlides.forEach((slide) => this.ratios.set(slide, 0));

    this.rafPending = false;

    this.observer = new IntersectionObserver(this.onIntersect.bind(this), {
      root: this.track,
      threshold: [0, 0.25, 0.5, 0.6, 0.75, 1],
    });
    this.allSlides.forEach((slide) => this.observer.observe(slide));

    this.dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        const mediaId = dot.dataset.mediaId;
        const targetSlide =
          this.allSlides.find(
            (s) => s.dataset.mediaId === mediaId && !s.classList.contains('slider__slide--clone')
          ) || this.allSlides.find((s) => s.dataset.mediaId === mediaId);
        if (!targetSlide) return;
        targetSlide.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
      });
    });
  }

  onIntersect(entries) {
    entries.forEach((entry) => {
      this.ratios.set(entry.target, entry.intersectionRatio);
    });

    // Batch recalculation via rAF to avoid thrashing on rapid-fire events
    if (this.rafPending) return;
    this.rafPending = true;
    requestAnimationFrame(() => {
      this.rafPending = false;
      this.updateActiveDotFromRatios();
    });
  }

  updateActiveDotFromRatios() {
    let bestSlide = null;
    let bestRatio = -1;
    this.ratios.forEach((ratio, slide) => {
      if (ratio > bestRatio) {
        bestRatio = ratio;
        bestSlide = slide;
      }
    });
    if (!bestSlide || bestRatio <= 0) return;

    const mediaId = bestSlide.dataset.mediaId;
    const dotIndex = this.dotIndexByMediaId.get(mediaId);
    if (dotIndex === undefined) return;
    this.setActiveDot(dotIndex);
  }

  setActiveDot(index) {
    this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
  }
}

function initMobileDotSliders() {
  document.querySelectorAll('.mobile-dots').forEach((el) => {
    if (el.dataset.dotSliderInit) return;
    el.dataset.dotSliderInit = 'true';
    new MobileDotSlider(el);
  });
}

document.addEventListener('DOMContentLoaded', initMobileDotSliders);
document.addEventListener('shopify:section:load', initMobileDotSliders);